import FJActionAiVideoDub from '../../../../redux/action/FJActionAiVideoDub';
import FJAiVideoDubRightDefault from '../view/FJAiVideoDubRightDefault';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import FJConstant from '../../../../constants/FJConstant';

const FJAiVideoDubRightDefaultContainer = ({ isShow }) => {
    const dispatch = useDispatch();
    const presetList = useSelector(state => state.aiVideoDub.presetList);
    const presetListStatus = useSelector(state => state.aiVideoDub.presetListStatus);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const generateSameKind = (item, callback) => {
        dispatch(FJActionAiVideoDub.generateSameKindAction(item, callback));
    };

    return (
        <FJAiVideoDubRightDefault
            presetList={presetList}
            presetListStatus={presetListStatus}
            generateSameKind={generateSameKind}
            active={headerTabIndex === FJConstant.CREATIONS && isShow}
        />
    );
};

FJAiVideoDubRightDefaultContainer.propTypes = {
    isShow: PropTypes.bool.isRequired,
};

export default FJAiVideoDubRightDefaultContainer;
